import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// 
import "./static/favicon.png";
import "./index.css";
import "./common.css";
// components
import "components/header/header";
import "components/footer/footer";
import "components/fullscreen_gallery/fullscreen_gallery";
import "components/arrowed_gallery/arrowed_gallery";
import "components/reviews/reviews";
import "components/doubled_gallery/doubled_gallery";
import "components/doubled_gallery_screen/doubled_gallery_screen";
import "components/doubled_tours_screen/doubled_tours_screen";
import "components/about_us_block/about_us_block";
import "components/mandela_block/mandela_block";
import "components/partners/partners";
import "components/contact_us/contact_us";
import "components/booking/booking";
import "components/tours_list/tours_list";
import "components/people_gallery/people_gallery";
// pages
import "components/index_page/index_page";
import "components/destinations_page/destinations_page";
import "components/destination_page/destination_page";
import "components/journeys_page/journeys_page";
import "components/journey_page/journey_page";
import "components/tour_page/tour_page";
import "components/about_page/about_page";
import "components/blog_page/blog_page";
import "components/post_page/post_page";
import "components/text_page/text_page";
import "components/contact_us_page/contact_us_page";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const intersectionCallback = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      }
    };
    const observer = new IntersectionObserver(intersectionCallback);

    const items = document.querySelectorAll(".animated_block");
    for (const item of items) {
      observer.observe(item);
    }
  },
  false,
);

gsap.registerPlugin(ScrollToPlugin) 
